<div class="main">
  <div class="section">
    <div class="headerText">
      <div class="heading">
        {{'USER_DETAILS.user' | translate}}
      </div>
      <div class="help">
        <app-help [helpData]="helpData"></app-help>
      </div>
      <div class="submitButton" (click)="openAddUserModal();">
        <div class="button">
          {{'USER_DETAILS.addUser' | translate}}
        </div>
      </div>
    </div>
    <!-- <div class="buttonSection">
          <div class="buttons" *ngIf="showButtons" (click)="optInWhatsApp();">
            <div class="button">
              <img src="assets/whatsApp-icon-green.svg">
              <span>{{'USER_DETAILS.optIn' | translate}}</span>
            </div>
          </div>
        </div> -->
    <div class="userTable">
      <table mat-table *ngIf="userArray.length" [dataSource]="userArray" class="loadTable">

        <!-- <ng-container matColumnDef="selected">
                <th mat-header-cell *matHeaderCellDef class="customHeader">Select </th>
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox (change)="selectUser($event, element)" [(ngModel)]="element.selected" ></mat-checkbox>
                </td>
              </ng-container> -->
        <ng-container matColumnDef="serialnumber">
          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'USER_DETAILS.serial_number' | translate}} </th>
          <td mat-cell *matCellDef="let element; let i = index" style="width: 100px;"> {{i+1}} </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'USER_DETAILS.name' | translate}} </th>
          <td mat-cell *matCellDef="let element" style="width: 100px;"> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="units">
          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'USER_DETAILS.units' | translate}} </th>
          <td mat-cell *matCellDef="let element" style="width: 250px;">
            <span *ngFor="let item of element.units; let i=index">
              {{item.name}}
              <span *ngIf="(element.units.length > 1) && (i != element.units.length-1)">,<br></span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'USER_DETAILS.email' |
            translate}}/{{'USER_DETAILS.mobile' | translate}} </th>
          <td mat-cell *matCellDef="let element" style="width: 150px;"> {{element.email}}/{{element.mobile}} </td>
        </ng-container>

        <!-- <ng-container matColumnDef="mobile">
                    <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'USER_DETAILS.mobile' | translate}} </th>
                    <td mat-cell *matCellDef="let element" style="width: 100px;"> {{element.mobile}} </td>
                </ng-container> -->

        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'USER_DETAILS.roles' | translate}} </th>
          <td mat-cell *matCellDef="let element" style="width: 150px;">
            <span *ngFor="let item of element.roles; let i=index">
              {{item.name}}
              <span *ngIf="(element.roles.length > 1) && (i != element.roles.length-1)">,<br></span>
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="functions">
          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'USER_DETAILS.functionalities' | translate}}
          </th>
          <td mat-cell *matCellDef="let element" style="width: 150px;">
            <span *ngFor="let item of element.functions; let i=index">
              {{item.name}}
              <span *ngIf="(element.functions.length > 1) && (i != element.functions.length-1)">,</span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastsignin">
          <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'USER_DETAILS.last_signin' | translate}} </th>
          <td mat-cell *matCellDef="let element" style="width: 150px;">
            <span>
              {{(element.lastsignin)}}
            </span>
          </td>
        </ng-container>



        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="customHeader">{{'USER_DETAILS.actions' | translate}} </th>
          <td mat-cell *matCellDef="let element" style="width: 100px;">
            <div class="buttons">
              <div class="button" [ngStyle]="{'background-color': element.owner ? '#8e8e8e':''}">
                <mat-select [placeholder]="'USER_DETAILS.actions' | translate">
                  <mat-option *ngIf="!element.owner" (click)="editUser(element);">
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-edit.svg" alt="">
                    {{'USER_DETAILS.editButton' | translate}}
                  </mat-option>
                  <mat-option *ngIf="element.alive">
                    <span  (click)="blockUser(element);">
                      <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-block.svg" alt="">
                      {{'USER_DETAILS.block' | translate}}
                    </span>
                  </mat-option>
                  <!-- <mat-option>
                                  <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-block.svg"   alt=""> {{'USER_DETAILS.blockButton' | translate}}
                                </mat-option> -->
                </mat-select>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="userColumns;sticky: true" style="font-weight: bold !important;"></tr>
        <tr mat-row *matRowDef="let row; columns: userColumns;"></tr>

      </table>
    </div>
  </div>
</div>